import { isValidEmail } from "../helpers";

export function validateLogin(values) {
    let errors = {}

    if (!values.email)
        errors.email = "Email is required"
    else if (!isValidEmail(values.email))
        errors.email = "Email is invalid"
    else if (!values.password)
        errors.password = "Password is required"

    return errors;
}